// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"780":"810d9366","826":"d7c3e597"}[chunkId] + ".chunk.js");